import { IsNotEmpty, IsString } from "class-validator";

export class EarlyAccessGroupDto {
	public id: string;
	public name: string;
	public accessCode: string;
	public createdAt: Date;
	public updatedAt: Date;
}

export class CreateEarlyAccessGroupDto {
	@IsNotEmpty()
	@IsString()
	public name: string;
}

export class UpdateEarlyAccessGroupDto {
	@IsString()
	public name?: string;

	@IsString()
	public accessCode?: string;
}
